/**
 * SPDX-FileCopyrightText: 2022 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

export const hiddenTags = {
	forwarded: '',
	hasattachment: '',
	has_cal: '',
	'has cal': '',
	hasnoattachment: '',
	notjunk: '',
	loadremoteimages: '',
	'unsubscribe newsletter': '',
}
